/* TOO MUCH home: every product appears once. Grids and rails render their limit plus spare products (hidden,
   data-tm-spare). Walking the page top to bottom, a product already shown higher up is hidden and the next
   spare in the same section takes its place, so rows stay full. Colour siblings share one key (the primary). */
(function () {
  function run() {
    var seen = Object.create(null);
    /* Round 3 QA: products picked by hand for a look ("How we would wear it", data-tm-reserve) stay in the look, so
       the grids and rails skip them wherever they sit on the page (Sac Anjou Mini showed in Bags and in the look). */
    Array.prototype.forEach.call(document.querySelectorAll('[data-tm-reserve]'), function (el) {
      var key = el.getAttribute('data-tm-reserve');
      if (key) seen[key] = true;
    });
    var groups = document.querySelectorAll('[data-tm-unique-group]');
    Array.prototype.forEach.call(groups, function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('[data-tm-key]'));
      var limit = items.filter(function (el) { return !el.hasAttribute('data-tm-spare'); }).length;
      var shown = 0;
      items.forEach(function (el) {
        var key = el.getAttribute('data-tm-key');
        var show = !seen[key] && shown < limit;
        el.hidden = !show;
        if (show) {
          seen[key] = true;
          shown += 1;
        }
      });
      if (shown === 0 && group.hasAttribute('data-tm-hide-empty')) group.hidden = true;
      // a short rail (1-3 products) switches to a split layout so the row has no empty half
      group.toggleAttribute('data-tm-few', shown > 0 && shown < 4);
      group.setAttribute('data-tm-count', String(shown));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
